import React from "react";
import { useSelector } from "react-redux";

import GalleryModal from "./components/Gallery.modal";
import ListModal from "./components/List.modal";
import TitleModal from "./components/Title.modal";

const SpecsBodyMobile = ({ data, title, icon, type }) => {
  const productImages = useSelector(
    (state) => state.modal.contentModal?.images
  );
  const galleryImages =
    data.img && data.img.length > 0 ? data.img : productImages;

  return (
    <>
      <div className="d-flex align-items-center mb-4 interactive-title">
        <span className="me-2">{icon}</span>
        {title ? <TitleModal title={title} /> : <h6>{type}</h6>}
      </div>
      <div
        className="col-12 col-lg-6 h-lg-100"
        style={{ position: "relative" }}
      >
        <GalleryModal minImg={false} gallery={galleryImages} />
      </div>

      <div className="col-12 col-lg-6 py-3 ">
        <div style={{ height: "calc(100vh - 332px)", overflow: "auto" }}>
          <div className="py-3">
            <ListModal list={data.specifiche} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SpecsBodyMobile;
